import React from 'react';
import styles from 'stylesheets/micro-scholarships.module.scss';
import {CardContainer} from 'shared/micro-scholarships/components/opportunity-card';

interface Props {
  institutionName: string;
}

const JoinClubsCTACard = ({institutionName}: Props) => {
  const settings = {
    title: (name: string) => {
      if (name && name.length <= 28) {
        return `Join clubs at ${name}`;
      }

      return 'Join clubs at your high school today';
    },
    subtitle:
      'View the most popular clubs at your school, earn Micro-Scholarships and sign up as a club leader.',
  };

  const content = (
    <div className={styles.content}>
      <h2>{settings.title(institutionName)}</h2>
      <p>{settings.subtitle}</p>
    </div>
  );

  return <CardContainer className={styles.JoinClubsCardContainer}>{content}</CardContainer>;
};

export default JoinClubsCTACard;
